import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "../apis/API";

export const getPixel = () => {
  return api.post(`${ApiEndpointConstants.GET_PIXEL}`, {});
};

export const getFbPixel = (url) => {
  return api.post(`https://www.adminv.online/api/Urlrelation/getUrlrelationUrl`, {url});
};
